import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EventEnum } from '@as-react/common-types';
import { Box, Button, CenterDialog, Stack, TextAlpha } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DELAY } from '../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useEventListener } from '../../hooks/useEventListener';
import { useTimeout } from '../../hooks/useTimeout';
export const SessionExpiredDialog = () => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const [showDialog, setShowDialog] = useState(false);
    useEventListener(EventEnum.SHOPLANDING_SESSION_EXPIRED, () => {
        setShowDialog(true);
    });
    const onClose = () => {
        window.location.reload();
    };
    useTimeout(onClose, { delay: DELAY.DELAY_30000, enabled: showDialog });
    return (_jsxs(CenterDialog, { isOpen: showDialog, onClose: onClose, size: "680px", children: [_jsx(CenterDialog.Content, { children: _jsx(Box, { paddingBlockStart: "2", paddingBlockEnd: "12", children: _jsxs(Stack, { direction: "col", gap: 6, children: [_jsx(TextAlpha, { variant: "headingS", children: t('shoplanding.session.expired.message') }), _jsx(TextAlpha, { children: t('shoplanding.session.expired.description') })] }) }) }), _jsx(CenterDialog.Footer, { children: _jsx(Stack, { justify: "end", children: _jsx(Button, { theme: "branded", onClick: onClose, children: t('shoplanding.session.expired.button') }) }) })] }));
};
